module.exports = __webpack_public_path__ + "static/media/team9.beef9ae7.png";